import { useEffect, useState } from 'react'
import { useParams, Link } from 'react-router-dom'
import axios from 'axios'

export function ReportsDetail() {
  const { reportId } = useParams()
  const [report, setReport] = useState<any | null>(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    const fetchReport = async () => {
      try {
        const res = await axios.get(`https://api.finapp.aerotage.com/api/reports/${reportId}`)
        setReport(res.data)
      } catch (e) {
        // noop
      } finally {
        setLoading(false)
      }
    }
    if (reportId) fetchReport()
  }, [reportId])

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">Loading…</div>
    )
  }

  if (!report || report.error === 'not_found') {
    return (
      <div className="space-y-6">
        <div className="bg-white shadow rounded-lg p-6">
          <h2 className="text-2xl font-bold mb-4">Report not found</h2>
          <Link className="text-blue-600" to="/reports">Back to Reports</Link>
        </div>
      </div>
    )
  }

  return (
    <div className="space-y-6">
      <div className="bg-white shadow rounded-lg p-6">
        <div className="flex items-center justify-between mb-4">
          <h2 className="text-2xl font-bold">{report.ticker} — {report.recommendation}</h2>
          <div className="text-gray-500 text-sm">{new Date(report.generated_at || report.created_at).toLocaleString()}</div>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          <div>
            <div className="text-gray-600 text-sm">Current Price</div>
            <div className="text-2xl font-bold">${Number(report.current_price ?? 0).toFixed(2)}</div>
          </div>
          <div>
            <div className="text-gray-600 text-sm">Target Price</div>
            <div className="text-2xl font-bold">{report.target_price != null ? `$${Number(report.target_price).toFixed(2)}` : 'N/A'}</div>
          </div>
          <div>
            <div className="text-gray-600 text-sm">Confidence</div>
            <div className="text-2xl font-bold">{report.confidence != null ? `${Math.round(Number(report.confidence) * 100)}%` : 'N/A'}</div>
          </div>
          <div>
            <div className="text-gray-600 text-sm">Risk Level</div>
            <div className="text-2xl font-bold capitalize">{report.risk_level || 'N/A'}</div>
          </div>
        </div>
        <div className="mt-6">
          <Link className="text-blue-600" to="/reports">Back to Reports</Link>
        </div>
      </div>
    </div>
  )
}
